var forms = {

    init: function () {

        // Fetch all the forms, apply Bootstrap validation and prevent submit
        var forms = document.getElementsByClassName('plain-validation');
        Array.prototype.filter.call(forms, (form) => {
            form.addEventListener('submit', function (event) {
                if (!validateForm(form)) {
                    event.preventDefault();
                    event.stopPropagation();
                }
                form.classList.add('was-validated');
            }, false);

            // change password form
            if(form.classList.contains('js-change-password')) {
                this.initChangePasswordForm(form);
            }
        });

        // auto scroll to validation summary
        var $validationSummary = document.querySelector('.js-show-validation-summary');
        if($validationSummary){
            setTimeout(() => $validationSummary.scrollIntoView(true), 800);
        }
    },

    initChangePasswordForm: function(form){
        let pwFields = form.querySelectorAll('input[type=password]');
        pwFields.forEach((field) => {
            field.addEventListener('keyup', (e) => {
                field.classList.add('js-dirty');
                pwMustMatch();
            })
        })

        const pwMustMatch = function(){
            let pw1 = document.getElementById('newPassword');
            let pw2 = document.getElementById('confirmNewPassword');
            let msg = document.getElementById('passwordMsg');
            let match = pw1.value === pw2.value;

            if(pw1.classList.contains('js-dirty') && pw2.classList.contains('js-dirty')) {
                msg.classList.toggle('d-none', match);
            }
        }
    }
}

function validateForm(form) {
    var valid = true;
    if(form.checkValidity() === false || form.classList.contains('js-invalid')) {
        valid = false;
    }

    if([].some.call(form.classList, x => /js-invalid-.+/.test(x))) {
        valid = false;
    }

    return valid;
}

export default forms;
